import React from 'react';
import "../../css/MenuManagement.css"
import TableDropDownButtonIcon from "../../assets/Icons/TableDropDownButtonIcon.svg";
import TableDropDownOpenButton from "../../assets/Icons/TableDropDownOpenButton.svg";

const MenuCard = ({ title, isActive, onToggle, options, toggleStatus, onToggleChange }) => {
  return (
    <div className="menu-card">
      <div className={`menu-card-header ${isActive && "menu-card-header-active"}`} onClick={onToggle}>
        <button className={`menu-dropdown-btn ${isActive ? 'open' : ''}`}>
          <img src={isActive ? TableDropDownOpenButton : TableDropDownButtonIcon} alt="Dropdown Button" />
        </button>
        <h3 className='menu-card-title'>{title}</h3>
      </div>
      {isActive && (
        <div className="menu-card-content">
          <ul>
            {options.map((option, index) => (
              <li key={index}>
                {option}
                <button
                  style={{
                    display: "flex",
                    border: "none",
                    background: "none",
                    cursor: "pointer",
                    marginLeft: "10px"
                  }}
                  onClick={() => onToggleChange(index)}
                >
                  <div
                    style={{
                      width: "40px",
                      height: "20px",
                      borderRadius: "20px",
                      background: toggleStatus[index] ? "#00b6ce" : "#fff",
                      border: "2px solid #00b6ce",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: toggleStatus[index] ? "flex-end" : "flex-start",
                      padding: "2px",
                      transition: "background 0.3s, justify-content 0.3s"
                    }}
                  >
                    <div
                      style={{
                        width: "12px",
                        height: "12px",
                        borderRadius: "50%",
                        background: "#fff",
                        border: toggleStatus[index] ? "none" : "2px solid #00b6ce",
                        transition: "background 0.3s, border 0.3s"
                      }}
                    ></div>
                  </div>
                </button>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};


export default MenuCard;
